import { useRouter } from 'next/router'
import { useState } from 'react'

const useReloadPage = () => {
  const router = useRouter()

  const [reloading, setReloading] = useState(false)

  const reload = () => {
    setReloading(true)
    router.reload()
  }

  return {
    reload,
    reloading,
  }
}

export default useReloadPage
